import { render, staticRenderFns } from "./SelImage.vue?vue&type=template&id=70470580&scoped=true"
import script from "./SelImage.vue?vue&type=script&lang=js"
export * from "./SelImage.vue?vue&type=script&lang=js"
import style0 from "./SelImage.vue?vue&type=style&index=0&id=70470580&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70470580",
  null
  
)

export default component.exports